export class StateBar {
  data: Array<any> = [];
  stateTopBar: any;
  headersTopBar: any;
  asegurado_seleccionado: any;
  headerMobile: any;
  dataMobile: any;
}
